import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import { SpaceCreationDialog } from '../../Space';

export interface CreateSiteContentButtonProps
    extends Pick<ButtonProps, 'className' | 'label' | 'size' | 'kind' | 'onPress'> {
    organization: api.Organization;
    site: api.Site;
}

export function CreateSiteContentButton(props: CreateSiteContentButtonProps) {
    const { className, label, size, kind, organization, site, onPress } = props;
    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    kind={kind}
                    leadingIcon={Icon.Plus}
                    label={label}
                    className={className}
                    size={size}
                    onPress={onPress}
                />
            </DialogTrigger>
            <SpaceCreationDialog organizationId={organization.id} target={{ type: 'site', site }} />
        </DialogRoot>
    );
}
